var _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeStoresGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H6.13227C5.91145 0 5.69063 0.105469 5.57018 0.263672L4.28538 2.0918C3.60283 3.04102 4.20508 4.3418 5.44973 4.48242C5.5501 4.5 5.6304 4.5 5.73078 4.5C6.33302 4.5 6.85497 4.27148 7.21632 3.91992C7.57767 4.27148 8.09962 4.5 8.70187 4.5C9.19947 4.5 9.65307 4.33305 10 4.06502V0Z",
    fill: "#9296AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.75H7.00214V5.00977C6.80139 5.04492 5.93152 5.0625 5.73078 5.0625C5.61033 5.0625 5.48988 5.0625 5.36943 5.04492C5.24898 5.02734 5.1486 5.00977 5.04823 4.99219V8.4375C5.04823 8.75391 5.32928 9 5.69063 9H10V6.75Z",
    fill: "#9296AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H13.8677C14.0885 0 14.3094 0.105469 14.4298 0.263672L15.7146 2.0918C16.3972 3.04102 15.7949 4.3418 14.5503 4.48242C14.4499 4.5 14.3696 4.5 14.2692 4.5C13.667 4.5 13.145 4.27148 12.7837 3.91992C12.4223 4.27148 11.9004 4.5 11.2981 4.5C10.8005 4.5 10.3469 4.33305 10 4.06502V0Z",
    fill: "#9296AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.75H12.9979V5.00977C13.1986 5.04492 14.0685 5.0625 14.2692 5.0625C14.3897 5.0625 14.5101 5.0625 14.6306 5.04492C14.751 5.02734 14.8514 5.00977 14.9518 4.99219V8.4375C14.9518 8.75391 14.6707 9 14.3094 9H10V6.75Z",
    fill: "#9296AC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 10H11.7769C11.5929 10 11.4089 10.0938 11.3085 10.2344L10.2378 11.8594C9.66903 12.7031 10.1709 13.8594 11.2081 13.9844C11.2918 14 11.3587 14 11.4423 14C11.9442 14 12.3791 13.7969 12.6803 13.4844C12.9814 13.7969 13.4163 14 13.9182 14C14.3329 14 14.7109 13.8516 15 13.6134V10Z",
    fill: "#9296AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16H12.5018V14.4531C12.3345 14.4844 11.6096 14.5 11.4423 14.5C11.3419 14.5 11.2416 14.5 11.1412 14.4844C11.0408 14.4688 10.9572 14.4531 10.8735 14.4375V17.5C10.8735 17.7812 11.1077 18 11.4089 18H15V16Z",
    fill: "#9296AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10H18.2231C18.4071 10 18.5911 10.0938 18.6915 10.2344L19.7622 11.8594C20.331 12.7031 19.8291 13.8594 18.7919 13.9844C18.7082 14 18.6413 14 18.5577 14C18.0558 14 17.6209 13.7969 17.3197 13.4844C17.0186 13.7969 16.5837 14 16.0818 14C15.6671 14 15.2891 13.8516 15 13.6134V10Z",
    fill: "#9296AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16H17.4982V14.4531C17.6655 14.4844 18.3904 14.5 18.5577 14.5C18.6581 14.5 18.7584 14.5 18.8588 14.4844C18.9592 14.4688 19.0428 14.4531 19.1265 14.4375V17.5C19.1265 17.7812 18.8923 18 18.5911 18H15V16Z",
    fill: "#9296AC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 10H1.7769C1.59288 10 1.40885 10.0938 1.30848 10.2344L0.237817 11.8594C-0.330973 12.7031 0.170901 13.8594 1.20811 13.9844C1.29175 14 1.35867 14 1.44231 14C1.94419 14 2.37914 13.7969 2.68027 13.4844C2.98139 13.7969 3.41635 14 3.91822 14C4.33289 14 4.71089 13.8516 5 13.6134V10Z",
    fill: "#9296AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16H2.50179V14.4531C2.3345 14.4844 1.6096 14.5 1.44231 14.5C1.34194 14.5 1.24156 14.5 1.14119 14.4844C1.04081 14.4688 0.957169 14.4531 0.873523 14.4375V17.5C0.873523 17.7812 1.10773 18 1.40885 18H5V16Z",
    fill: "#9296AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10H8.2231C8.40712 10 8.59115 10.0938 8.69152 10.2344L9.76218 11.8594C10.331 12.7031 9.8291 13.8594 8.79189 13.9844C8.70825 14 8.64133 14 8.55769 14C8.05581 14 7.62086 13.7969 7.31973 13.4844C7.01861 13.7969 6.58365 14 6.08178 14C5.66711 14 5.28911 13.8516 5 13.6134V10Z",
    fill: "#9296AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16H7.49821V14.4531C7.6655 14.4844 8.3904 14.5 8.55769 14.5C8.65806 14.5 8.75844 14.5 8.85881 14.4844C8.95919 14.4688 9.04283 14.4531 9.12648 14.4375V17.5C9.12648 17.7812 8.89227 18 8.59115 18H5V16Z",
    fill: "#9296AC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStoresGray);
export default __webpack_public_path__ + "static/media/threeStoresGray.93173c280635ab9f4e1a7d085aaef67c.svg";
export { ForwardRef as ReactComponent };